import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import useHackathon from '@/data/hook/hackathon/useHackathon';
import useAuth from '@/data/hook/useAuth';
import ProjectPermissions from '@/utils/permissions/ProjectPermission';
import Card from '../Card';
import ProjectCardProps from './ProjectCardProps';

export default function CreateHackathonProjectCard({
  project,
  onMutate,
  className,
}: ProjectCardProps) {
  const { user } = useAuth();
  const { hackathon, isLoading } = useHackathon();

  const permissions = new ProjectPermissions({
    user,
    model: project,
    hackathon,
    isLoadingHackathon: isLoading,
  });

  return (
    <Card key={project.id} project={project} className={className?.base}>
      <ConditionalRenderer condition={permissions.canInteract()}>
        <Card.Interactions project={project} onMutate={onMutate} />
      </ConditionalRenderer>
      <Card.Banner url={project.image} />
      <Card.FlexGroup>
        <Card.Title title={project.title} className="grow" />
        <Card.HackathonVotingAction project={project} onMutate={onMutate} />
      </Card.FlexGroup>
      <Card.Tags tool={project.tool} flags={project.flags} />
      <Card.FlexGroup>
        <Card.PublushDate publishAt={project.createdAt} />
        <Card.Owners owners={project.users} />
      </Card.FlexGroup>
    </Card>
  );
}
